import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {TwoJointIkSolver, Vrm} from '@wonderlandengine/components';
import {quat, quat2, vec3} from 'gl-matrix';

const _tempVec = vec3.create();
const _tempQuat = quat.create();
const _tempTransform = quat2.create();

const tempVec = vec3.create();
const tempVec0 = vec3.create();

/**
 * paintball-vrm-ik
 */
export class PaintballVrmIk extends Component {
    static TypeName = 'paintball-vrm-ik';

    /* Properties that are configurable in the editor */

    @property.string()
    src!: string;

    @property.string('Avatar_LeftArm') leftRoot!: string;
    @property.string('Avatar_LeftForeArm') leftMiddle!: string;
    @property.string('Avatar_LeftHand') leftEnd!: string;
    @property.string('Avatar_RightArm') rightRoot!: string;
    @property.string('Avatar_RightForeArm') rightMiddle!: string;
    @property.string('Avatar_RightHand') rightEnd!: string;

    armature!: Object3D;
    eyeCenter!: Object3D;
    rcTarget!: Object3D;
    lcTarget!: Object3D;
    headTarget!: Object3D;
    avatarHead!: Object3D;

    private headRotationY = 0;
    private headRotationX = -60;
    private offset!: Object3D;
    private lcHelper!: Object3D;
    private rcHelper!: Object3D;
    private ready = false;
    private tempArray = new Float32Array(8);

    modelLoaded = false;
    loadedModel: Object3D | null = null;

    body: Object3D | null = null;

    loadVrm() {
        console.error('hello from vrm ik 3');

        this.body = this.object.findByNameRecursive('Body')[0];
        /**@ts-ignore */
        this.engine.scene.append(this.src).then((root: Object3D) => {
            //saving the loaded model here for afteruse
            this.armature = root;

            //making the avatar halfbody by scaling down legs
            this.armature!.findByNameRecursive('Avatar_LeftUpLeg')![0].setScalingLocal([
                0, 0, 0,
            ]);
            this.armature!.findByNameRecursive('Avatar_RightUpLeg')![0].setScalingLocal([
                0, 0, 0,
            ]);

            this.armature!.findByNameRecursive(this.leftRoot)![0].setScalingWorld([
                0.001, 0.001, 0.001,
            ]);
            this.armature!.findByNameRecursive(this.rightRoot)![0].setScalingWorld([
                0.001, 0.001, 0.001,
            ]);

            //reparent the object to this.object from scen root
            //this.armature!.parent = this.body;

            //this.object is the body object in paintball, and it has a down scaling
            //so resetting the scaling to 1,1,1 for getting the actul avatar size
            this.body!.setScalingWorld([1, 1, 1]);

            //now we are offsetting the position of the avatar w.r.t the body object ( left ,down , Back )
            //TODO we should be offsetting the gun position instead of the avatar,Comment this line if you do that !
            //TODO figure out logic to do this only for non-vr mode
            this.armature!.findByNameRecursive('root')[0].translateLocal([
                -0.0, -0.5, -0.0,
            ]);

            this.armature!.findByNameRecursive('root')[0].rotateAxisAngleDegLocal(
                [0, 1, 0],
                180
            );

            //setup Ik

            //add TwoJointIK component to the loaded model for left and right arm
            this.setupIk();
        });
    }

    setupIk() {
        const objs = this.engine.scene.addObjects(6, this.armature);
        [
            this.offset,
            this.rcTarget,
            this.lcTarget,
            this.headTarget,
            this.lcHelper,
            this.rcHelper,
        ] = objs;
        this.offset.name = 'offset';

        this.rcTarget.name = 'rcTarget';
        this.rcTarget.parent = this.offset;
        this.lcTarget.name = 'lcTarget';
        this.lcTarget.parent = this.offset;
        this.headTarget.name = 'headTarget';
        this.headTarget.parent = this.offset;

        const leftArm = this.armature.findByNameRecursive(this.leftRoot)[0];
        const leftForeArm = leftArm.findByNameRecursive(this.leftMiddle)[0];
        const leftHand = leftForeArm.findByNameRecursive(this.leftEnd)[0];

        this.lcHelper.name = 'lcHelper';
        this.lcHelper.parent = leftHand;
        this.lcHelper.resetPositionRotation();
        this.lcHelper.translateLocal([0, -1, 0]);
        // leftArm.addComponent(TwoJointIkSolver, {
        //     root: leftArm,
        //     middle: leftForeArm,
        //     end: leftHand,
        //     target: this.lcTarget,
        //     copyTargetRotation: true,
        //     helper: this.lcHelper,
        // });

        const rightArm = this.armature.findByNameRecursive(this.rightRoot)[0];
        const rightForeArm = rightArm.findByNameRecursive(this.rightMiddle)[0];
        const rightHand = rightForeArm.findByNameRecursive(this.rightEnd)[0];

        this.rcHelper.name = 'rcHelper';
        this.rcHelper.parent = rightHand;
        this.rcHelper.resetPositionRotation();
        this.rcHelper.translateLocal([0, -1, 0]);
        // rightArm.addComponent(TwoJointIkSolver, {
        //     root: rightArm,
        //     middle: rightForeArm,
        //     end: rightHand,
        //     target: this.rcTarget,
        //     copyTargetRotation: true,
        //     helper: this.rcHelper,
        // });

        this.avatarHead = this.armature.findByNameRecursive('Avatar_Head')[0];
        this.ready = true;
        this.armature.resetRotation();
    }

    update() {
        /* Called every frame. */
        if (!this.ready) return;

        let isNonVr = this.engine.xr ? false : true;

        //TODO copy up and down rotation from nonVR?gun:Head to headTarget

        //TODO copy left and right rotation from nonVR?gun:Head to Armature
        const head = isNonVr
            ? this.object.findByNameRecursive('Gun')[0]
            : this.object.findByNameRecursive('Head')[0];

        if (head) {
            //this.copyRot(head, this.headTarget,0);
            this.copyRot(head, this.armature, 1);
        }

        const gun = this.object.findByNameRecursive('Gun')[0];
        const hand = this.object.findByNameRecursive('Hand')[0];
        const body = this.object.findByNameRecursive('Body')[0];

        this.rcTarget.setTransformWorld(gun.getTransformWorld(_tempTransform));
        this.rcTarget.rotateAxisAngleDegObject([1, 0, 0], 90);
        this.lcTarget.setTransformWorld(body.getTransformWorld(_tempTransform));
        const tempPos = body.getPositionWorld(_tempVec);
        //tempPos[1] -= 0.5;
        this.armature.setPositionWorld(tempPos);
    }

    copyRot(head: Object3D, armature: Object3D, axis: number) {
        head.getForwardWorld(tempVec);
        tempVec[axis] = 0; //
        vec3.normalize(tempVec, tempVec);
        armature.getPositionWorld(tempVec0);
        vec3.add(tempVec, tempVec, tempVec0);
        armature.lookAt(tempVec);
    }
}
